export default __webpack_public_path__ + "static/media/profile.74d59d5d.png";